import {filter, find, get, indexOf, map, values} from "lodash";
import moment from "moment";

const availableScreens = ['default', 'potential_match', 'awaiting_mentor_response','group_hold'];

export const getScreenIndex = (screen) => indexOf(availableScreens, screen) + 1;

export const getScreenDetail = (list, listName) => filter(list, listItem => listItem.key === listName)[0];


export const statuses = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  SUCCESS: 'SUCCESS',
}


export const getTimeRemaining = (timeStamp, durationToExpire) => {
  const timeOfExpiary = moment(timeStamp).add(durationToExpire, 'hour')
  // Clamped: the backend sweeps expiry on its own schedule, so a match can still
  // be ACTIVE past its deadline. Without this the card counts down into
  // negatives — "expires in -1 days, -3 hrs".
  const minutesLeft = Math.max(timeOfExpiary.diff(moment(), 'minutes'), 0)
  const timetoExpiary = moment.duration(minutesLeft, 'minutes')

  return {
    days: timetoExpiary.get('days'),
    hours: timetoExpiary.get('hours'),
    minutes: timetoExpiary.get('minutes'),
  }
}


export const timeRemainingMessage = (time) => `${time.days} days, ${time.hours} hrs, ${time.minutes} mins`

export const expiryTiers = {OK: 'ok', SOON: 'soon', URGENT: 'urgent'};

export const expiryTier = (time) => {
  if (time.days <= 0) {
    return expiryTiers.URGENT
  }
  return time.days <= 2 ? expiryTiers.SOON : expiryTiers.OK
}


export const isMatchActive = (match) => match.status === 'ACTIVE';

export const getSubTitle = (match) => {
  const userInfo = []
  map(values(match.userInfo), info => map(info, val => userInfo.push(val)))

  return userInfo.join(', ')
}

export const trackerStatus = {
  REJECTED: 'REJECTED',
  INTERESTED: 'INTERESTED',
};

export const groupCompatibilityStatus = {
  INCOMPATIBLE: 'INCOMPATIBLE',
  COMPATIBLE: 'COMPATIBLE',
  GROUP_FULL: 'GROUP_FULL',
  PAIR_COMPLETE: 'PAIR_COMPLETE',
};

export const matchType = {
  many: "1toM",
  one: "1to1",
};

export const isOneToOne = (match) => match === matchType.one;
export const isOneToMany = (match) => match === matchType.many;

// Matching is over for good once a mentorship is running — the pair-up support
// offer has nothing left to help with.
export const hasActiveMentorship = (status) => Boolean(get(status, 'activeMentorship'));

export const isMatchingOpen = (status) => {
  const ACTIVE_STATUSES = ['READY', 'ON_HOLD','GROUP_HOLD'];
  return !!find(ACTIVE_STATUSES, activeStatus => activeStatus === get(status, 'matching.matchingStatus'))
}
